import { ReactNode } from 'react';
import { ButtonProps } from '@wix/design-system';
import { ModalName } from '../../../constants/ModalName';

export type TModalOptionsState = {
  [modalName in ModalName]?: Partial<{
    isOpen: boolean;
    additionalOptions: any;
    closeParams: any;
  }>;
};

export enum ActionType {
  SetOpen = 'set-open',
  SetCloseParams = 'set-close-params',
}

export interface IModalOptionsAction {
  type: ActionType;
  payload: {
    modalName: ModalName;
    isOpen?: boolean;
    additionalOptions?: TAdditionalOptions;
    closeParams?: TCloseParams;
  };
}

export interface IModalOptionsContext {
  state: TModalOptionsState;
  openedModal: ModalName;
  openModal: (modalName: ModalName, additionalOptions?: TAdditionalOptions) => void;
  closeModal: (modalName: ModalName) => void;
  setCloseParams: (modalName: ModalName, closeParams?: TCloseParams) => void;
}

export enum Theme {
  Destructive = 'destructive',
  Premium = 'premium',
  Standard = 'standard',
}

export interface IModalOptions {
  content: ReactNode;
  title?: ReactNode;
  image?: ReactNode;
  width?: string;
  confirmText?: ReactNode;
  cancelText?: ReactNode;
  confirmButtonProps?: ButtonProps;
  disableCancel?: boolean;
  disableConfirmation?: boolean;
  theme?: Theme;
  hideFooter?: boolean;
  noBodyPadding?: boolean;
  sideActions?: ReactNode;
  customLayout?: boolean;
  shouldCloseOnOverlayClick?: boolean;
  onOpen?(additionalOptions: TAdditionalOptions): void;
  onOk?(additionalOptions: TAdditionalOptions): void;
  onClose?(closeParams: TCloseParams): void;
  onCancel?(additionalOptions: TAdditionalOptions): void;
  onCloseWithCloseButtonClick?(closeParams: TCloseParams): void;
  onCloseWithOverlayClick?(closeParams: TCloseParams): void;
  onHelpButtonClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export type TAdditionalOptions = { [key: string]: any };
export type TCloseParams = { [key: string]: any };
